import { combineReducers } from 'redux'
import { reducer as app } from './app/reducers'
import { reducer as workflow } from './workflow/reducers'
import { reducer as garage } from './garage/reducers'
import { reducer as booking } from './booking/reducers'
import { reducer as availability } from './availability/reducers'

export const rootReducer = combineReducers({
  app,
  workflow,
  garage,
  availability,
  booking
})
